module.exports = __webpack_public_path__ + "static/media/pill_handshake.b07d55ea.jpg";